export class AnetProfile {
  UserID: string;
  FirstName: string;
  LastName: string;
  CustomerID: string;
  Email: string;
  CompanyName: string;
  isTest: boolean;
}
